import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import ReactTooltip from 'react-tooltip';

import { Switch } from '../../shared';

import {
  getIcon,
  currentUserIsSuperAdmin,
  appConfig,
  generateUnsafeHash,
} from '../../../util';

const NEW_ITEM = {
  name: '',
  description: '',
  scored: true,
}

class ManageExpertiseSection extends Component{

  state = {
    syncingChanges: false,
    expertiseItems: [],
    addingNewItem: null,
    editingItem: null,
  }

  isEditingItem(item){
    return this.state.editingItem && this.state.editingItem.id === item.id;
  }

  toggleEditingItem(item){
    if(item && item.id){
      this.setState({
        editingItem: item
      });
    }
    else{
      this.setState({
        addingNewItem: this.state.addingNewItem ? null : NEW_ITEM
      });
    }
  }

  renderExpertiseItem(item){

    const {
      id,
      name,
      description,
      scored,
      _deleted,
    } = item;

    return (
      <div key={`expertise-item-${item.id}`} className={`expertise-item ${_deleted ? 'deleted' : ''}`}>
        <div className="id">{!_deleted ? id : 'DELETED'}</div>
        <div className="name">{name}</div>
        <div className="scored">{scored ? 'Yes' : 'No'}</div>
        {_deleted &&
          <div className="actions">
            <div onClick={() => { let restored = {...item}; delete restored['_deleted']; this.saveItemChanges(restored); }} className="action restore">Restore</div>
          </div>
        }
        {!_deleted &&
          <div className="actions">
            <div onClick={() => { this.toggleEditingItem(item); }} className="action edit">Edit</div>
            <div onClick={() => { this.saveItemChanges({ ...item, _deleted: true }); }} className="action delete">Delete</div>
          </div>
        }
      </div>
    )
  }

  componentWillMount(){
    if(this.props.organization.expertiseItems && !_.isEqual(this.state.expertiseItems, this.props.organization.expertiseItems)){
      this.setState({
        expertiseItems: this.props.organization.expertiseItems || []
      });
    }
  }

  componentDidUpdate(prevProps, prevState){
    console.log('componentDidUpdate');
  }

  renderExpertiseItems(){
    if(this.state.editingItem || this.state.addingNewItem){
      return null;
    }

    return (
      <div className="expertise-items">
        <div className="labels">
          <div className="id">Id</div>
          <div className="name">Expertise Label</div>
          <div className="scored">Score in 180 Reviews?</div>
          <div className="actions">Actions</div>
        </div>
        {_.map(this.state.expertiseItems, this.renderExpertiseItem.bind(this))}
      </div>
    );
  }

  renderEditExpertiseItem(){
    const {
      editingItem
    } = this.state;

    if(!editingItem){
      return null;
    }

    return this.renderItemEditArea(editingItem);
  }

  beginAddingNewItem(){
    this.setState({
      addingNewItem: {
        name: '',
        description: '',
        scored: false,
      }
    });
  }

  updateItem(item, updates){
    if(item.id){
      this.setState({
        editingItem: {
          ...item,
          ...updates
        }
      });
    }
    else{
      //updating new item
      this.setState({
        addingNewItem: {
          ...item,
          ...updates
        }
      });
    }
  }
  saveItemChanges(item){
    // console.log('saveItemChanges: ', item);

    if(item.id){
      const existingItemIndex = _.findIndex(this.state.expertiseItems, { id: item.id });
      let newExpertiseItems = _.cloneDeep(this.state.expertiseItems);

      newExpertiseItems.splice(existingItemIndex, 1, item);

      this.setState({
        expertiseItems: newExpertiseItems,
        editingItem: null,
      });
    }
    else{
      //add new item
      this.setState({
        expertiseItems: [
          ...this.state.expertiseItems,
          {
            id: generateUnsafeHash(),
            ...item,
          }
        ],
        addingNewItem: null
      });
    }
  }

  renderItemEditArea(item){
    return (
      <div className="item-edit-area">
        <div className="edit-group">
          <div className="name">Item Label</div>
          <input type="text" value={item.name} onChange={e => { this.updateItem(item, { name: e.target.value }); }} />
        </div>
        <div className="edit-group">
          <div className="description">Item Description</div>
          <textarea value={item.description} onChange={e => { this.updateItem(item, { description: e.target.value }); }}></textarea>
        </div>
        <div className="edit-group">
          <div className="score">Score in 180 Reviews?</div>
            <Switch
              id="new-item-scored"
              checked={item.scored || false}
              onChange={checked => { this.updateItem(item, { scored: checked }); }}
            />
        </div>
        <div className="actions">
          <button disabled={!item.name || item.name === ''} onClick={() => { this.saveItemChanges(item); }} className="button button-sm light-blue-button">{item.id ? ('Update') : ('Add')}</button>
          <button onClick={() => { this.setState({ editingItem: null, addingNewItem: null }); }} className="button button-sm grey-outline">Cancel</button>
        </div>
      </div>
    )
  }

  renderAddNewExpertiseItem(){

    const {
      addingNewItem,
      editingItem,
    } = this.state;

    return (
      <div className="add-new-expertise-item">
        {addingNewItem && this.renderItemEditArea(addingNewItem)}
        {!addingNewItem && !editingItem &&
          <div onClick={() => { this.toggleEditingItem(); }} className="add-new-toggle">Add new</div>
        }
      </div>
    )
  }

  pageIsDirty(){
    return !_.isEqual(this.props.organization.expertiseItems || [], this.state.expertiseItems);
  }

  revertAllChanges(){
    this.setState({
      expertiseItems: this.props.organization.expertiseItems || []
    });
  }
  saveAllChanges(){
    if(this.state.syncingChanges){
      return;
    }
    this.setState({
      syncingChanges: true
    });

    this.props.updateOrganizationProps({
      expertiseItems: this.state.expertiseItems
    });

    //do stuff to save
  }

  renderPageActions(){

    const {
      syncingChanges
    } = this.state;

    return (
      <React.Fragment>
        <button disabled={syncingChanges} onClick={this.saveAllChanges.bind(this)} className="button primary">{syncingChanges ? 'Syncing...' : 'Sync Changes'}</button>
        {!syncingChanges &&
          <button onClick={this.revertAllChanges.bind(this)} className="button grey-outline">Undo All</button>
        }
      </React.Fragment>
    )
  }

  render(){

    return (
      <div className="manage-expertise">
        <div className="page-section">
          {this.renderExpertiseItems()}
          {this.renderEditExpertiseItem()}
          {this.renderAddNewExpertiseItem()}
        </div>
        <div className="bottom-page-actions">
          {this.pageIsDirty() && this.renderPageActions()}
          {!this.pageIsDirty() &&
            <p>All changes synced.</p>
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {

  }
}

export default connect(mapStateToProps, {})(ManageExpertiseSection);



// WEBPACK FOOTER //
// ./src/components/settings/sections/manageExpertiseSection.js